import React, {useState} from 'react';
import classNames from "classnames";

function Rating({initRating, className, setValue}){

    const [rating, setRating] = useState(initRating-1);
    const stars = [1,2,3,4,5];
    const [hover, setHover] = useState(false);

    const starsClass = classNames("d-flex align-items-center justify-content-center "+className)

    return (
        <div className={starsClass}>
            {
                stars.map(star => (
                    <i className={"bi text-warning fs-4 m-0 me-1 "+(star <= rating ? " bi-star-fill " : " bi-star ") + (hover ? " bi-star-fill " : "")} onMouseEnter={() => setHover(true)} onClick={() => {
                        console.log("STAR: ", star)
                        setRating(star)
                        setValue(star)
                    }} />
                ))
            }

        </div>


    );

}

export default Rating;